import { useEffect, useRef } from 'react';
import { useLocation } from 'umi';
import { useLocalState } from '@/pages/aigc/pages/Agent/ChatPage/hooks/useLocalState';
import { COPILOT_LEFT_MENU_COLLAPSED_KEY } from '@/pages/aigc/pages/Agent/config/constant';

/** 是否因 Copilot 内嵌停靠而收起左侧菜单 */
export function useCopilotLeftMenuCollapsed() {
  return useLocalState<boolean>(COPILOT_LEFT_MENU_COLLAPSED_KEY, false);
}

/** 订阅 Copilot 收起态：expanded=true 展开，false 收起 */
export function useSyncCopilotLeftMenuCollapse(
  applyExpanded: (expanded: boolean) => void,
): void {
  const [collapsed] = useCopilotLeftMenuCollapsed();
  const { pathname } = useLocation();
  const isAgentPage = pathname?.split('/')[1] === 'agent';
  const applyRef = useRef(applyExpanded);
  applyRef.current = applyExpanded;
  useEffect(() => {
    // agent 页面无 copilot 功能，跳过收起
    if (isAgentPage) return;
    // 仅 Copilot 要求收起时收起菜单；
    // 关闭/恢复信号（collapsed=false）不做任何操作，菜单保持现状，避免关闭 Copilot 后被强制展开
    if (!collapsed) return;
    applyRef.current(false);
  }, [collapsed, isAgentPage]);
}
